import { render } from "./ListeMonnaie.vue?vue&type=template&id=1aac4026&ts=true"
import script from "./ListeMonnaie.vue?vue&type=script&lang=ts"
export * from "./ListeMonnaie.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__